import announceFormStatus, { clearFormStatus } from '../../form_status';

// A <button> submits unless its type says otherwise, missing type included.
const SUBMIT_CONTROLS =
  'input[type=submit], button:not([type=button], [type=reset])';

function setBusy(entry, busyLabel) {
  entry.busy = true;
  entry.form.setAttribute('aria-busy', 'true');

  entry.buttons.forEach(({ button, idleLabel }) => {
    button.setAttribute('aria-disabled', 'true');
    if (busyLabel && idleLabel !== null) button.value = busyLabel;
  });
}

function setIdle(entry) {
  entry.busy = false;
  entry.form.removeAttribute('aria-busy');
  clearFormStatus('submitting');

  entry.buttons.forEach(({ button, idleLabel }) => {
    button.removeAttribute('aria-disabled');
    if (idleLabel !== null) button.value = idleLabel;
  });
}

// Locking is only safe when the submission unloads the document, and `target`
// approximates that: a response landing elsewhere would leave the form stuck.
const trackedForms = Array.from(
  document.querySelectorAll('form:not([data-async]):not([target])'),
).map(form => {
  // On a <button>, `value` is the data its activation posts, not its label:
  // writing there would corrupt the submission and still show nothing.
  const buttons = Array.from(form.querySelectorAll(SUBMIT_CONTROLS)).map(
    button => ({
      button,
      idleLabel: button.tagName === 'INPUT' ? button.value : null,
    }),
  );

  const entry = { form, buttons, busy: false };

  form.addEventListener('submit', event => {
    if (entry.busy) {
      event.preventDefault();
      return;
    }

    setBusy(entry, announceFormStatus('submitting'));

    // A client-side validator may cancel the submission after this listener:
    // the form has to become usable again instead of staying locked.
    setTimeout(() => {
      if (!event.defaultPrevented || form.checkValidity()) return;

      setIdle(entry);
    }, 0);
  });

  return entry;
});

// A bfcache restore hands the page back with this realm untouched, lock
// included: without an explicit release the form comes back unsubmittable.
window.addEventListener('pageshow', event => {
  if (!event.persisted) return;

  trackedForms.forEach(entry => {
    if (entry.busy) setIdle(entry);
  });
});
